import { render, staticRenderFns } from "./enviromentalPredictiveRisk.vue?vue&type=template&id=4f72a5ca"
import script from "./enviromentalPredictiveRisk.vue?vue&type=script&lang=js"
export * from "./enviromentalPredictiveRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports